<template>
  <div class="title_box">
    <div class="left">
        <img :src="icon" alt="📈" class="icon">
        <div class="title">{{ title }}</div>
    </div>
    <div class="right">
      <van-checkbox :icon-size="16" v-model="checked" shape="square" checked-color="#2877FF">
      <span :class="check()">只看带货视频</span>
      </van-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    title:String,
    icon:String
  },
  data() {
    return {
      checked:false
    }
  },
 watch:{
  checked:{
      handler(newVal,oldVal) {
        this.$emit('checked',newVal)
      }
    },
 },
  methods: {
    check() {
      return this.checked ? 'color' : ''
    }
  }
}
</script>

<style scoped lang='less'>
.color {
  color:#2877FF;
}
.title_box {
    display: flex;
    justify-content: space-between;
    padding: 10px 12px 0 12px;
    background-color: #fff;
    .left {
        display: flex;
        align-items: center;
        .icon {
            width: 20px;
            height: 20px;
            margin-right: 4px;
        }
        .title {
            font-weight: 500;
            font-size: 16px;
            color: #141B27;
        }
    }
}
</style>
